var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "rb-tags-input" }, [
    _c(
      "div",
      _vm._b({ staticClass: "ui-select-container" }, "div", _vm.$attrs, false),
      [
        _c("div", { staticClass: "main" }, [
          _c(
            "div",
            {
              staticClass:
                "inputs ng-pristine ng-valid ng-valid-pattern ng-valid-maxlength",
              class: { "border-primary": _vm.focused },
              attrs: { name: "vm.tagForm" }
            },
            [
              _c("SearchInput", {
                ref: "nameEl",
                staticStyle: { width: "133px" },
                attrs: {
                  datalist: _vm.autoCompleteTags,
                  placeholder: "New tag name",
                  pattern: "[a-zA-Z0-9_-]*",
                  type: "text",
                  maxlength: "30"
                },
                on: { change: _vm.onTagSelected },
                model: {
                  value: _vm.input.name,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.input,
                      "name",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "input.name"
                }
              }),
              _vm._v(" "),
              _c("span", [_vm._v(":")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.input.textValue,
                    expression: "input.textValue"
                  }
                ],
                ref: "valueEl",
                staticClass:
                  "tagValue form-control no_border m-b-0 p-l-3 ng-pristine ng-untouched ng-valid ng-empty",
                staticStyle: { width: "133px" },
                attrs: {
                  id: "txtValue",
                  name: "txtValue",
                  autocomplete: "off",
                  placeholder: "value",
                  "input-autoresize": "",
                  disabled: !_vm.input.name
                },
                domProps: { value: _vm.input.textValue },
                on: {
                  keydown: _vm.onValueKeyDown,
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.input, "textValue", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "input",
                  staticStyle: {
                    visibility: "hidden",
                    width: "auto",
                    "white-space": "pre",
                    display: "none"
                  }
                },
                [_vm._v("New tag name")]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "input",
                  staticStyle: {
                    visibility: "hidden",
                    width: "auto",
                    "white-space": "pre",
                    display: "none"
                  }
                },
                [_vm._v("value")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-success btn-sm m-l-10",
              attrs: { disabled: !_vm.valid },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.addTag()
                }
              }
            },
            [_vm._v("\n        Add Tag\n      ")]
          )
        ]),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "tags ui-select-match flex-row" },
          _vm._l(_vm.value, function(item, index) {
            return _c("span", { key: index }, [
              _c(
                "span",
                {
                  staticClass: "ui-select-match-item btn btn-default btn-xs",
                  attrs: {
                    tabindex: "-1",
                    type: "button",
                    disabled: item.disabled,
                    "ui-select-sort": "$select.selected"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "close ui-select-match-close",
                      on: {
                        click: function($event) {
                          return _vm.removeTagByIndex(index)
                        }
                      }
                    },
                    [_vm._v(" ×")]
                  ),
                  _vm._v(" "),
                  _c("span", { attrs: { "uis-transclude-append": "" } }, [
                    _c(
                      "span",
                      { staticClass: "tag-selected-name ng-binding ng-scope" },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(item.tagName) +
                            ":\n              "
                        ),
                        _c(
                          "div",
                          { staticClass: "tag-selected-value ng-binding" },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(item.tagValue) +
                                "\n              "
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ]
              )
            ])
          }),
          0
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }